import React from "react";
import { Button, Table } from "react-bootstrap";
import { BsMapFill, BsPlusCircleFill, BsXCircleFill } from "react-icons/bs";
import { GrEdit } from "react-icons/gr";
import { RiArrowLeftLine, RiMapPin2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

function normalizeProtocolCode(value) {
  return String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "")
    .replace(/_/g, "-");
}

function isExtendedProtocol(protocolCode) {
  const code = normalizeProtocolCode(protocolCode);
  return code === "MT-3" || code === "MT-03" || code === "MT-3-JSON" || code === "MT-03-JSON";
}

export function CoordenadasTabla({ datos, datosAEditar, handleEliminar, handleShowModal, handleShowMapModal, protocoloVista }) {
  const navigation = useNavigate();
  const showButtonByte = isExtendedProtocol(protocoloVista);

  return (
    <div className="coordenadas-section">
      <div className="coordenadas-header">
        <Button className="coordenadas-back-button" onClick={() => navigation("/rutas")}>
          <RiArrowLeftLine /> Atras
        </Button>

        <div className="coordenadas-heading">
          <div className="coordenadas-eyebrow">
            <RiMapPin2Line /> Coordenadas
          </div>
          <h1 className="coordenadas-title">Coordenadas de la ruta</h1>
        </div>

        <div className="coordenadas-header-actions">
          <Button variant="outline-light" className="coordenadas-map-button" onClick={handleShowMapModal}>
            <BsMapFill /> Ver todas las geocercas en el mapa
          </Button>
          <Button variant="success" className="coordenadas-add-button" onClick={() => handleShowModal("Nuevo")}>
            <BsPlusCircleFill /> Agregar
          </Button>
        </div>
      </div>

      <div className="coordenadas-table-shell">
        <div className="table-responsive coordenadas-table-responsive">
          <Table striped bordered hover className="coordenadas-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Latitud - Longuitud</th>
              <th>Radio</th>
              <th>Velocidad</th>
              <th>Sonido Velocidad</th>
              <th>Sonido Geocerca</th>
              {showButtonByte && <th>Tiempo audio velocidad</th>}
              {showButtonByte && <th>Tiempo audio geocerca</th>}
              {showButtonByte && <th>Valor botón</th>}
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {datos &&
              datos.map((coordenada) => (
                <tr key={coordenada.id}>
                  <td>{coordenada.id}</td>
                  <td>{coordenada.coordenadas}</td>
                  <td>{coordenada.radio}</td>
                  <td>{coordenada.sonidosVelocidadModel ? coordenada.sonidosVelocidadModel.nombre : ""}</td>
                  <td>{coordenada.sonidosVelocidadModel ? coordenada.sonidosVelocidadModel.codvel : ""}</td>
                  <td>{coordenada.sonidosGeocercaModel.codsonido}</td>
                  {showButtonByte && <td>{Number.isFinite(Number(coordenada.tiempoAudioVelocidad)) ? coordenada.tiempoAudioVelocidad : 0}</td>}
                  {showButtonByte && <td>{Number.isFinite(Number(coordenada.tiempoAudioGeocerca)) ? coordenada.tiempoAudioGeocerca : 0}</td>}
                  {showButtonByte && <td>{Number.isFinite(Number(coordenada.valorBoton)) ? coordenada.valorBoton : 0}</td>}
                  <td className="coordenadas-actions-cell">
                    <div className="responsive-table-actions">
                      <Button variant="warning" onClick={() => datosAEditar(coordenada)}>
                        <GrEdit /> Editar
                      </Button>
                      <Button variant="danger" onClick={() => handleEliminar(coordenada.id)}>
                        <BsXCircleFill /> Eliminar
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
